import { useEffect, useState } from 'react';

/** Jitter below this many pixels does not count as a direction change. */
const SCROLL_DELTA_THRESHOLD_PX = 8;

export type ScrollDirection = 'up' | 'down';

/**
 * The direction of the last meaningful window scroll. Starts as 'down' so
 * anything shown-while-scrolling-down is visible before the user scrolls at
 * all.
 */
export const useScrollDirection = (): ScrollDirection => {
  const [direction, setDirection] = useState<ScrollDirection>('down');

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;
      if (Math.abs(delta) < SCROLL_DELTA_THRESHOLD_PX) return;
      setDirection(delta > 0 ? 'down' : 'up');
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return direction;
};
